import { InstanceTypeOf } from '@/type-utils';
import { errorFactory } from '@/utils/error-utils';
import { InvalidArgumentError } from '@/utils/errors';

export const { SwatchValidationError } = errorFactory(
  'SwatchValidationError',
  InvalidArgumentError
);

/**
 * Base error for swatch validation failures.
 *
 * Thrown when a swatch has invalid or missing color data that prevents rendering.
 * This error is caught by SwatchErrorBoundary to display an ErrorSwatch or hide
 * the swatch based on environment configuration.
 */
export type SwatchValidationError = InstanceTypeOf<
  typeof SwatchValidationError
>;
